export enum Access {
    Unknown = 0,
    Privileged = 1,
    NonPrivileged = 2,
    NoLogicalAcceess = 3,
}